export default __webpack_public_path__ + "static/media/SnowCover.ee9b5c56.webm";